import type { NowItem } from '../lib/types';

type Props = { items: NowItem[]; asOf: Date };

export function Now({ items, asOf }: Props) {
  return (
    <section
      id="section-now"
      className="section"
      style={{
        padding: '56px 28px',
      }}
    >
      <div
        className="grid-now"
        style={{
          display: 'grid',
          gridTemplateColumns: '220px 1fr',
          gap: 48,
        }}
      >
        <div>
          <div className="eyebrow" style={{ marginBottom: 10 }}>
            § 03 · Present tense
          </div>
          <div
            className="serif italic"
            style={{ fontSize: 'var(--fs-display)', lineHeight: 0.95, letterSpacing: -1.8 }}
          >
            Now.
          </div>
          <div
            style={{
              fontSize: 10,
              marginTop: 14,
              opacity: 0.5,
              textTransform: 'uppercase',
              letterSpacing: 1.2,
            }}
          >
            Last updated · {asOf.toLocaleDateString()}
          </div>
        </div>
        <div>
          {items.map((n, i) => (
            <div
              key={n.id ?? i}
              style={{
                padding: '12px 0',
                borderTop: i === 0 ? '1px solid var(--ink)' : 'none',
                borderBottom: '1px solid var(--ink)',
                display: 'grid',
                gridTemplateColumns: '40px 1fr auto',
                gap: 16,
                alignItems: 'baseline',
              }}
            >
              <span style={{ opacity: 0.5 }}>{String(i + 1).padStart(2, '0')}</span>
              <span className="serif" style={{ fontSize: 19, lineHeight: 1.4 }}>
                {n.body}
              </span>
              <span
                style={{
                  fontSize: 10,
                  opacity: 0.55,
                  textTransform: 'uppercase',
                  letterSpacing: 0.7,
                }}
              >
                active
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
